/**
 * Seleção levada do relatório de KPIs de endereços externos para o CRUD de Candidatos,
 * que a recebe pré-selecionada para revalidar. Vai pela sessionStorage (e não pela URL) para
 * comportar centenas de ids, e é consumida uma única vez.
 */
const CHAVE = 'revalidacaoSelecao';
const VALIDADE_MS = 10 * 60 * 1000;

/** Origem do relatório (E/P/C) -> aba (`mainTab`) do CRUD de Candidatos. */
export const ABA_POR_ORIGEM = { E: 0, P: 1, C: 2 };

/** @param {{ origem: 'E'|'P'|'C', ids: Array<number|string> }} selecao */
export function salvarSelecaoRevalidacao(selecao) {
  try {
    sessionStorage.setItem(CHAVE, JSON.stringify({ ...selecao, ts: Date.now() }));
  } catch (e) {
    // sessionStorage indisponível: o CRUD abre sem seleção.
  }
}

/** Lê e remove a seleção; null se não houver, estiver vencida ou inválida. */
export function consumirSelecaoRevalidacao() {
  try {
    const bruto = sessionStorage.getItem(CHAVE);
    if (!bruto) return null;
    sessionStorage.removeItem(CHAVE);
    const selecao = JSON.parse(bruto);
    if (!selecao || !(selecao.origem in ABA_POR_ORIGEM) || !Array.isArray(selecao.ids) || !selecao.ids.length) return null;
    if (Date.now() - Number(selecao.ts) > VALIDADE_MS) return null;
    return { origem: selecao.origem, ids: selecao.ids };
  } catch (e) {
    return null;
  }
}
